import { MEMBER_ENV, localServerUrl, devServerUrl, prodServerUrl, FILE_PORTAL_URL } from "../../config/config";

export const generateFileURL = (file: any): string => {
	const fileURL = `${FILE_PORTAL_URL}/api/v1/file/${file.filename}`;

	return fileURL;
};
